var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVentaRenta = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 9.71998L12 1.97998L2.04004 9.71998L3.27004 11.3L4.09004 10.66V20.13C4.09004 21.17 4.94004 22.02 5.98004 22.02H18.03C19.07 22.02 19.92 21.17 19.92 20.13V10.66L20.74 11.3L21.97 9.71998H21.96ZM13.92 20.02H10.08V13.31H13.92V20.02ZM17.91 20.02H15.92V11.31H8.08004V20.02H6.09004V9.10998L12 4.50998L17.91 9.10998V20.02Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVentaRenta, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/venta_renta.391eb2d5.svg";
export { ForwardRef as ReactComponent };